module.exports = __webpack_public_path__ + "img/bleken.33d36e42.jpg";